import React, { useState, useRef } from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";

const ResourcesMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsOpen(false);
    }, 50);
  };

  return (
    <div
      className="relative"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <span
        className="text-foreground hover:text-nation-blue transition-colors cursor-pointer inline-flex items-center gap-1"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        Resources
        <ChevronDown className="h-4 w-4" />
      </span>

      {isOpen && (
        <div className="absolute top-full left-0 mt-2 w-72 bg-background border border-border rounded-lg shadow-lg z-50">
          <div className="py-2">
            <Link
              to="/polls"
              className="block px-4 py-3 text-sm font-medium text-foreground hover:bg-muted/50 hover:text-nation-blue transition-colors border-b border-border/50"
            >
              <div className="font-semibold">Public Polls</div>
              <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
                View public polls and participate in citizen surveys
              </p>
            </Link>
            <Link
              to="/insights"
              className="block px-4 py-3 text-sm font-medium text-foreground hover:bg-muted/50 hover:text-nation-blue transition-colors border-b border-border/50"
            >
              <div className="font-semibold">Insights</div>
              <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
                Browse data-driven insights by country and region
              </p>
            </Link>
            <Link
              to="/civic-education"
              className="block px-4 py-3 text-sm font-medium text-foreground hover:bg-muted/50 hover:text-nation-blue transition-colors border-b border-border/50"
            >
              <div className="font-semibold">Civic Education</div>
              <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
                Access educational content on democracy and governance
              </p>
            </Link>
            <Link
              to="/countries"
              className="block px-4 py-3 text-sm font-medium text-foreground hover:bg-muted/50 hover:text-nation-blue transition-colors"
            >
              <div className="font-semibold">Countries</div>
              <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
                Explore all available countries and regions
              </p>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default ResourcesMenu;
